import { PricingSummaryResponseBuilder } from './PricingSummaryResponseBuilder';
import { PaymentResponseBuilder } from './PaymentResponseBuilder';
import { EnrichedOfferOptionResponseBuilder } from './EnrichedOfferOptionResponseBuilder';
import { OfferOptionResponseBuilder } from './OfferOptionResponseBuilder';
import { AvailableOptionResponseBuilder } from './AvailableOptionResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class OfferResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Offer');
    }
    public withActivityId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityId'] = this.initField(null, args);
        return this;
    }

    public withOfferId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerId'] = this.initField(null, args);
        return this;
    }

    public withSupplierActivityCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierActivityCode'] = this.initField(null, args);
        return this;
    }

    public withSupplierOfferCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierOfferCode'] = this.initField(null, args);
        return this;
    }

    public withOfferDetailRef = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerDetailRef'] = this.initField(null, args);
        return this;
    }

    public withPricingSummary = (builder: PricingSummaryResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['pricingSummary'] = this.initField(builder, args);
        return this;
    }

    public withPayment = (builder: PaymentResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['payment'] = this.initField(builder, args);
        return this;
    }

    public withIsAvailable = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isAvailable'] = this.initField(null, args);
        return this;
    }

    public withIsCartRestricted = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isCartRestricted'] = this.initField(null, args);
        return this;
    }

    public withIsCartEligible = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isCartEligible'] = this.initField(null, args);
        return this;
    }

    public withAllowMultipleBooking = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['allowMultipleBooking'] = this.initField(null, args);
        return this;
    }

    public withBookingRequirementRefId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingRequirementRefId'] = this.initField(null, args);
        return this;
    }

    public withStatus = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['status'] = this.initField(null, args);
        return this;
    }

    public withConfirmMinutes = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['confirmMinutes'] = this.initField(null, args);
        return this;
    }

    public withVoucherMinutes = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['voucherMinutes'] = this.initField(null, args);
        return this;
    }

    public withLeadMinutes = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['leadMinutes'] = this.initField(null, args);
        return this;
    }

    public withEnrichedOfferOption = (builder: EnrichedOfferOptionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['enrichedOfferOption'] = this.initField(builder, args);
        return this;
    }

    public withOfferOptions = (builder: OfferOptionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerOptions'] = this.initField(builder, args);
        return this;
    }

    public withOfferGroupId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerGroupId'] = this.initField(null, args);
        return this;
    }

    public withOfferGroupDetailRef = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerGroupDetailRef'] = this.initField(null, args);
        return this;
    }

    public withAvailableOptions = (builder: AvailableOptionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['availableOptions'] = this.initField(builder, args);
        return this;
    }

    public withSupplierId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['supplierId'] = this.initField(null, args);
        return this;
    }
}
